/**
 * MODULAR TEMPLATE TEST ENTRY POINT
 *
 * To test the modular template:
 * 1. Rename main.jsx to main_original.jsx
 * 2. Rename this file to main.jsx
 * 3. Run: npm run dev
 * 4. View at localhost:5173
 * 5. When done, swap the files back
 */
import { createRoot } from 'react-dom/client'
import './modular/App_template.css'
import App from './modular/App_template.jsx'

createRoot(document.getElementById('root')).render(<App />)
